/**
 * @file home
 * @author 陈恩浩
 */

import React, { Component } from "react";
import { WhyHatu, Teacher, Medie, Study } from "./components/index";
import { Header, Footer } from "../../components/basic";
import "./index.scss";

import { changePopup } from "src/redux/basicInfo";
import { connect } from "react-redux";
import Popout from "./components/popout";
import LazyLoad from "react-lazyload";

@connect((state) => state, { changePopup })
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  handleTrial = () => {
    this.props.changePopup({ type: "trial", status: true });
  };

  render() {
    let { popupInfo } = this.props.basicInfo;
    let classesList = [
      {
        title: "课程丰富",
        intro:
          "精心划分的三大类数十门课程，匹配不同年龄层、不同水平段的学员需求",
      },
      {
        title: "专业严谨",
        intro: "自主研发课程受国家版权中心保护，科学定级，针对性强，实用性高",
      },
      {
        title: "趣味性强",
        intro: "多样化的互动小游戏和辅助动漫视频，寓教于乐，让孩子爱上中文学习",
      },
    ];

    return (
      <div className="home">
        {popupInfo.type === "trial" && <Popout history={this.props.history} />}

        <Header />
        <div style={{ height: "60px", width: 0 }}></div>
        <div className="banner" onClick={this.handleTrial}></div>

        <LazyLoad>
          <WhyHatu />
        </LazyLoad>

        <div
          className="home-experience"
          style={{ backgroundColor: "#fffdf7", marginBottom: "40px" }}
        >
          <div className="inner">
            <div className="inner-title">报名学习流程</div>
          </div>
          <LazyLoad>
            <img
              width="1193px"
              style={{ margin: "20px auto 50px", display: "block" }}
              alt=""
              src={require("@/images/home/circle.png")}
            />
          </LazyLoad>
        </div>

        <LazyLoad>
          <Study />
        </LazyLoad>

        <div className="home-experience" style={{ backgroundColor: "#fffdf7" }}>
          <div className="inner">
            <div className="inner-title">
              自主研发 适合华侨华人子女的中文课程
            </div>

            <ul className="classes">
              {classesList.map((item, index) => (
                <li className="classes-list" key={"classes-" + index}>
                  <div className="flip">
                    <div className="front">
                      <div className="title">{item.title}</div>
                    </div>
                    <div className="back">
                      <div className="title">{item.title}</div>
                      <div className="intro">{item.intro}</div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <LazyLoad>
          <img
            alt=""
            width="1300px"
            className="img"
            src={require("@/images/home/f1-tu1.jpg")}
            style={{ display: "block", margin: "40px auto" }}
          />
        </LazyLoad>

        <div className="home-btn" onClick={this.handleTrial}>
          免费领取试读课
        </div>

        <Teacher />
        <LazyLoad>
          <ul className="home-image">
            <li></li>
            <li></li>
            <li></li>
          </ul>
        </LazyLoad>

        <LazyLoad>
          <Medie />
        </LazyLoad>

        <div className="partner">
          <div className="inner-title" style={{ marginBottom: "14px" }}>
            哈兔中文无忧服务
          </div>
          <LazyLoad>
            <ul className="partner-layout">
              <li></li>
              <li></li>
              <li></li>
              <li></li>
            </ul>
          </LazyLoad>

          <div className="home-btn" onClick={this.handleTrial}>
            免费领取试读课
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Home;
